import { mapEnumToOptions } from '@abp/ng.core';

export enum QuestionGroupState {
  Inactive = 0,
  Active = 1,
}

export const questionGroupStateOptions = mapEnumToOptions(QuestionGroupState);
